import { Injectable } from '@angular/core';
import { CatalogResponse } from '@miq/catalog';
import { EntityType } from '@shared/models/entity-enum';
import { RecordType } from '../state/utils/current-record-type';
import { CompanyTabAccessService } from '@records/shared/company-tab-access.service';

export interface EntityDisablerFactoryServiceI {
  apply(response: CatalogResponse): CatalogResponse;
}

@Injectable({ providedIn: 'root' })
export class CompanyDisablerService implements EntityDisablerFactoryServiceI {
  constructor(private companyTabAccessService: CompanyTabAccessService) {}

  apply(response: CatalogResponse): CatalogResponse {
    const isAliasManager = this.companyTabAccessService.checkAliasManagerAccess();
    const sections = response[EntityType.Company];

    if (!isAliasManager && sections) {
      sections.forEach(section => {
        section.disabled = true;
        section.columns?.forEach(column => {
          column.isDisabled = true;
        });
      });
    }
    return response;
  }
}

@Injectable({ providedIn: 'root' })
export class EntityDisablerFactoryService {
  private _disablerMap = new Map<EntityType, EntityDisablerFactoryServiceI>();

  constructor(protected companyDisablerService: CompanyDisablerService) {
    this._disablerMap.set(EntityType.Company, this.companyDisablerService);
  }

  getService(entity: RecordType): EntityDisablerFactoryServiceI | undefined {
    const service = this._disablerMap.get(entity as EntityType);
    return service;
  }
}
